function init() {
  checkUrlParams();
}
function checkUrlParams() {
  const queryString = window.location.search; // 現在のURLのクエリ文字列
  // 許可するパラメータリスト
  const allowedParams = [
    '?company_cd=000002',
    '?company_cd=000010',
    '?company_cd=000011',
    '?company_cd=000012',
  ];
  const redirectBase = 'https://www2.uccard.co.jp/uc/platinum/';

  const isAllowed = allowedParams.some(param => queryString.startsWith(param));
  if (!isAllowed) {
    // 許可されないパラメータや無しの場合のリダイレクト
    let redirectUrl = redirectBase;
    if (queryString && queryString.startsWith('?')) {
      redirectUrl += queryString;
    }
    window.location.href = redirectUrl;
    return; // この時点で処理終了
  }

  // 許可パラメータの場合、ページ内の #link 内のリンクにパラメータを引き継ぐ
  const pageLink = document.querySelector('#js-lounge-link a');
  if (pageLink && queryString) {
    const separator = pageLink.href.includes('?') ? '&' : '?';
    pageLink.href += separator + queryString.substring(1); // "?"を除いて結合
  }
}


export default {
  init,
};